export const scopeData = [
    {
        id: 1,
        name: "Gas",
        placeholder: "Gas Natural en m3",
        label: "Gas Natural",
        co2: 2.01193,
        ch4: 0.00274,
        n2o: 0.00107
    },
    {
        id: 2,
        name: "Gasoil",
        placeholder: "Gasoil en L",
        label: "Gasoil",
        co2: 2.52058,
        ch4: 0.00026,
        n2o: 0.03700
    },
    {
        id: 3,
        name: "Nafta",
        placeholder: "Nafta en L",
        label: "Nafta",
        co2: 2.14805,
        ch4: 0.00720,
        n2o: 0.00660
    },
    {
        id: 4,
        name: "Fueloil",
        placeholder: "Fueloil en L",
        label: "Fueloil",
        co2: 3.16262,
        ch4: 0.00473,
        n2o: 0.00788
    },
    {
        id: 5,
        name: "Lpg",
        placeholder: "LPG en kg",
        label: "LPG",
        co2: 2.93518,
        ch4: 0.00228,
        n2o: 0.00183
    },
    {
        id: 6,
        name: "R22",
        placeholder: "R22 en Kg",
        label: "R22",
        co2: 1810,
        ch4: 0,
        n2o: 0
    },
    {
        id: 7,
        name: "R134",
        placeholder: "R134 en Kg",
        label: "R134",
        co2: 1100,
        ch4: 0,
        n2o: 0
    },
    {
        id: 8,
        name: "R407c",
        placeholder: "R407c en Kg",
        label: "R407c",
        co2: 1774,
        ch4: 0,
        n2o: 0
    },
    {
        id: 9,
        name: "R410a",
        placeholder: "R410a en Kg",
        label: "R410a",
        co2: 2088,
        ch4: 0,
        n2o: 0
    },
    {
        id: 10,
        name: "R141b",
        placeholder: "R141b en Kg",
        label: "R141b ",
        co2: 725,
        ch4: 0,
        n2o: 0
    },
    {
        id: 11,
        name: "Electricidad",
        placeholder: "Electricidad en kWh",
        label: "Electricidad",
        co2: 0.19121,
        ch4: 0.00080,
        n2o: 0.00137
    },
    {
        id: 12,
        name: "Vapor",
        placeholder: "Vapor en m3",
        label: "Vapor",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
    {
        id: 13,
        name: "Home",
        placeholder: "Hs de Home Office",
        label: "Home Office",
        co2: 0.34075,
        ch4: 0,
        n2o: 0
    },
    {
        id: 14,
        name: "Traslados",
        placeholder: "Nafta Transporte Privado",
        label: "Transporte Privado",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
    {
        id: 15,
        name: "Publico",
        placeholder: "km Transporte Publico",
        label: "Transporte Publico",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
    {
        id: 16,
        name: "Cabotaje",
        placeholder: "km Vuelos de Cabojate",
        label: "Vuelos Cabojate",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
    {
        id: 17,
        name: "Internacional",
        placeholder: "km Vuelos Internacionales",
        label: "Vuelos Internacionales",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
    {
        id: 18,
        name: "Alojamiento",
        placeholder: "Noches de Hotel",
        label: "Alojamiento",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
    {
        id: 19,
        name: "Terrestre",
        placeholder: "km Flete Terrestre",
        label: "Flete Terrestre",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
    {
        id: 20,
        name: "Maritimo",
        placeholder: "km Flete Marítimo/Aereo",
        label: "Flete Marítimo/Aereo",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
    {
        id: 21,
        name: "Agua",
        placeholder: "m3 Agua Consumida",
        label: "Agua Corriente",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
    {
        id: 22,
        name: "Tratamiento",
        placeholder: "m3 Agua Tratada",
        label: "Agua Tratada",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
    {
        id: 23,
        name: "Residuos",
        placeholder: "kg Residuos",
        label: "Residuos",
        co2: 1,
        ch4: 0,
        n2o: 0
    },
]
